import { combineReducers } from 'redux';
import app from './app';
import projects, { STATE_KEY as PROJECTS_STATE_KEY } from './projects';

export default combineReducers({
	app,
	[PROJECTS_STATE_KEY]: projects
});